export default {
	API_KEY : process.env.REACT_APP_API_KEY,
	API_ENDPOINT: "https://damp-fjord-29128.herokuapp.com",
	TOKEN_KEY: 'Ib-Tracker-client-auth-token',
	USER:"User",
	USERID:"UserId",
	PROFILEPIC:"ProfilePic",
	ISADMIN:"isAdmin"
};